//请自行添加语言资源
const printShipOrder = {

  msg:{

  }
};
export default printShipOrder



// WEBPACK FOOTER //
// ./src/page/yard/recovery/lang/recovery.zh.js